import { GetterTree } from 'vuex'
import { PushSubscribersState } from './types';
import { RootState } from '@/store/types';

export const getters: GetterTree<PushSubscribersState, RootState> = {
    pushSubscribers: state => state.pushSubscribers
};
